import { AuthContainer, AuthenticatorProvider } from "@pharaday/auth";
import { validateEmail } from "@pharaday/utils";
import { useQuery } from "@tanstack/react-query";

export const SIGN_IN_PRECHECK_QUERY_KEY = "/auth/signin/precheck";

export const useQuerySignInPrecheck = (email: string) => {
  return useQuery({
    queryKey: [SIGN_IN_PRECHECK_QUERY_KEY, email],
    queryFn: () => AuthContainer.get(AuthenticatorProvider).signInPrecheck(email),
    enabled: validateEmail(email),
  });
};
